<template>
  <div>
    <div class="m-b-20 ovf-hd">
      <div class="fl w-400">
        <el-input placeholder="请输入账号/操作编号/操作名称/所属菜单" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    border
    style="width: 100%"
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="code"
      label="操作编号">
      </el-table-column>
      <el-table-column
      prop="username"
      label="操作账号">
      </el-table-column>
      <el-table-column
      prop="time"
      label="操作时间">
      </el-table-column>
      <el-table-column
      prop="name"
      label="操作名称">
      </el-table-column>
      <el-table-column
      prop="count"
      label="操作数量">
      </el-table-column>
      <el-table-column
      prop="menu_name"
      label="所属菜单">
      </el-table-column>
      <el-table-column
      label="所属类型">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.type ==1" v-text="'添加数据'"></span>
            <span v-else-if = "scope.row.type ==2" v-text="'修改数据'"></span>
            <span v-else-if = "scope.row.type ==3" v-text="'删除数据'"></span>
            <span v-else-if = "scope.row.type ==4" v-text="'指定数据变更'"></span>
            <span v-else-if = "scope.row.type ==5" v-text="'指定数据批量变更'"></span>
            <span v-else-if = "scope.row.type ==6" v-text="'批量删除'"></span>
            <span v-else-if = "scope.row.type ==7" v-text="'批量添加'"></span>
            <span v-else-if = "scope.row.type ==8" v-text="'字段自增'"></span>
            <span v-else-if = "scope.row.type ==9" v-text="'字段自减'"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1">成功</span>
            <span v-else-if = "scope.row.status ==0" style="color:#0c0">已恢复</span>
            <span v-else-if = "scope.row.status ==-1" style="color:#d00">失败</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作前数据"
      width="100">
        <template scope="scope">
          <!-- <img style="width:60px;height: 60px;margin-top:8px;" :src='scope.row.wechat'> -->
          <el-popover trigger="click" placement="left" class="fl m-r-5" width="520" border="true">
            <div class="w-500">
              <p class="w-500">{{scope.row.y_remark}}</p>
            </div>
            <div slot="reference" class="name-wrapper">
              <el-button type="primary" size="small">
                详情
              </el-button>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      label="操作后数据"
      width="100">
        <template scope="scope">
          <!-- <img style="width:60px;height: 60px;margin-top:8px;" :src='scope.row.wechat'> -->
          <el-popover trigger="click" placement="left" class="fl m-r-5" width="520" border="true">
            <div class="w-500">
              <p class="w-500">{{scope.row.remark}}</p>
            </div>
            <div slot="reference" class="name-wrapper">
              <el-button type="primary" size="small">
                详情
              </el-button>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="100">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="recovery(scope.row.id,scope.row.code)" :disabled="(scope.row.status<=0) ?true:false">恢复</el-button>
            </span>
            <span>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'business'"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      abc(data) {
        this.showbtn = true
        console.log(data.links)
      },
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      recovery(id, code) {
        this.$confirm('确认要恢复操作编号为： ' + code + ' 下的所有数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiGet('admin/files_log/recovery?id=' + id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '恢复成功')
              setTimeout(() => {
                this.getAllUsers()
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiPost('admin/files_log/actionlog', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('tondun-save')
      },
      editShow() {
        return _g.getHasRule('tondun-update')
      },
      deleteShow() {
        return _g.getHasRule('tondun-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?2e1ffad0